module.exports = __webpack_public_path__ + "img/pillow.5a8d3199.png";